import truckallComponent from './truck.all.component';

let truckallModule = angular.module('truckall', [
  ])

  .component('truckall', truckallComponent)

  .name;

export default truckallModule;


// WEBPACK FOOTER //
// ./client/app/components/truck/all/index.js